import { render, staticRenderFns } from "./File-DropDown.vue?vue&type=template&id=b91bfe4c&"
import script from "./File-DropDown.vue?vue&type=script&lang=js&"
export * from "./File-DropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports